/* 🤖 this file was generated by script */
export const wiconLock03 = {
  name: 'lock_03',
  data: `<svg viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 11V8A5 5 0 007 8v3m1.8 10h6.4c1.68 0 2.52 0 3.16-.33a3 3 0 001.31-1.3c.33-.65.33-1.49.33-3.17v-.4c0-1.68 0-2.52-.33-3.16a3 3 0 00-1.3-1.31C17.71 11 16.87 11 15.2 11H8.8c-1.68 0-2.52 0-3.16.33a3 3 0 00-1.31 1.3C4 13.29 4 14.13 4 15.8v.4c0 1.68 0 2.52.33 3.16a3 3 0 001.3 1.31c.65.33 1.49.33 3.17.33z"/></svg>`,
};
